var mobileHeader = {
    base: {
        display: "grid",
        gridTemplateColumns: "repeat(3, max-content)",
        gap: 3,
        font: "body",
        width: "100%",
        height: "100%",
        bg: "brandDark.100",
        color: "white",
        px: 3,
        alignItems: "center",
        "[data-ui-logo-mark]": {
            fontSize: "iconMd",
        },
        "[data-nav-toggle]": {
            fontSize: "iconMd",
        },
    },
};

export { mobileHeader };
//# sourceMappingURL=mobile-header.js.map
